import React from 'react';
import { connect } from 'react-redux';

import styles from './styles';

const {
    UploaderContainer,
    UploaderInteractContainer,
} = styles;

class Uploader extends React.Component {
    render() {
        const {
            command,
            commandState: {
                data: {
                    commandStatus,
                },
                isLoaded,
                isLoading,
                error,
                commandName,
            },
            uploadFile,
        } = this.props;
        const SHOW_STATUS = isLoaded === true && command.commandName === commandName && commandStatus === 'completed';
        const SHOW_ERROR = error && error.message.length > 0 && command.commandName === commandName;
        const SHOW_LOADER = isLoading && !isLoaded && command.commandName === commandName;
        return (
            <UploaderContainer>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="file">Выберите файл для загрузки</label>
                <input
                    type="file"
                    name="file"
                    id="file"
                    accept="csv, xls, xlsx"
                />
                <UploaderInteractContainer>
                    <button type="button" onClick={() => uploadFile(command)}>Загрузить</button>
                    {SHOW_STATUS && <span>Загрузка файла успешно завершена</span>}
                    {SHOW_ERROR && <span>Выполнение команды {command.commandName} завершено с ошибкой. Сведения об ошибке: {error.message}</span>}
                    {SHOW_LOADER && <span>...Loading</span>}
                </UploaderInteractContainer>
            </UploaderContainer>
        );
    }
}

export default connect(
    state => ({
        commandState: state.app.commandState,
    }),
    {},
)(Uploader);
